import { CommonModule } from "@angular/common";
import {
    afterNextRender,
    Component,
    effect,
    inject,
    model,
    signal,
} from "@angular/core";
import { Router } from "@angular/router";
import { AlertService, Badge } from "@malirang/front-share";
import { injectQueryParams } from "ngxtension/inject-query-params";
import { injectNavigationEnd } from "ngxtension/navigation-end";
import { DocumentStore } from "../../store/document.store";
import { DocumentChildInfo } from "../document-child-info/document-child-info";
import { DocumentSelect } from "../document-select/document-select";
import { DocumentBoxComponent } from "./document-box/document-box.component";
import { ScheduleLogComponent } from "./schedule-log/schedule-log.component";
import { environment } from "../../../../../env/env";

type Segment = "document-box" | "schedule-log";

@Component({
    selector: "app-document-side-section",
    templateUrl: "./document-side-section.html",
    styleUrls: ["./document-side-section.css"],
    imports: [
        CommonModule,
        DocumentSelect,
        DocumentBoxComponent,
        ScheduleLogComponent,
        DocumentChildInfo,
        Badge,
    ],
})
export class DocumentSideSection {
    readonly documentStore = inject(DocumentStore);
    readonly alertService = inject(AlertService);
    readonly router = inject(Router);

    currentTicket = this.documentStore.currentTicket;
    currentChild = this.documentStore.currentChild;
    navigationEnd$ = injectNavigationEnd();

    segment = model<Segment>("document-box");
    documentId = injectQueryParams("documentId");
    ticketId = injectQueryParams("ticketId");

    open = signal<boolean>(true);

    constructor() {
        afterNextRender(() => {
            this.handleSegment();
            this.navigationEnd$.subscribe(() => this.handleSegment());
        });

        effect(() => {
            this.documentStore.setTicketId(this.ticketId());
        });
    }

    handleSegment() {
        if (this.router.url.includes("schedule-log")) {
            this.segment.set("schedule-log");
        } else {
            this.segment.set("document-box");
        }
    }

    handleRoute(url: string) {
        if (false && url === "/document/schedule-log") {
            this.alertService.warning("준비중입니다.");
            return;
        }

        this.router.navigate([url], {
            queryParamsHandling: "merge",
            queryParams: {
                documentId:
                    this.segment() === "document-box"
                        ? undefined
                        : this.documentId(),
            },
        });
    }

    async handleBack() {
        // 저장되지 않은 변경사항 체크
        if (
            this.documentStore.formDirty() &&
            !this.documentStore.formComplete()
        ) {
            const result = await new Promise<boolean>((resolve) => {
                this.alertService
                    .open({
                        title: "저장되지 않은 변경사항",
                        content: `저장하지 않은 변경사항이 있습니다.
                작성중인 문서를 저장하시겠습니까?`,
                        type: "info",
                        buttons: {
                            confirm: {
                                text: "저장",
                            },
                        },
                    })
                    .closed.subscribe({
                        next: (res) => {
                            resolve(res?.action === "confirm");
                        },
                    });
            });

            if (result && this.documentStore.formSaveHandler) {
                this.documentStore.formSaveHandler();
            }
        }

        this.router.navigate(["/document"], {
            replaceUrl: true,
        });
    }
}
